import { Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import User from "../models/User";

import ManagerBase from "./ManagerBase";

class UserManager extends ManagerBase {
	constructor () {
		super("userManager");

		this.responsesModelClass = User;
		this.remoteClassName = "user";
	}

	logIn (user) {
		var rd = NousCore.api.createRequest({ item: user.export("logIn") });
		const requestedAction = "login";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						user.import(data.items[0]);
						// userManager.emit("userLoggedIn");

						return {
							data: user,
							requestedAction,
							status: "ok"
						};
					default:
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}

	save (user) {
		// console.log(user);
		const rd = NousCore.api.createRequest({ item: user.export() });
		const requestedAction = user.guid === "" ? "insert" : "update";
	
		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			// console.log(data);
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						if (data.items.length > 0) {
							user.import(data.items[0]);
							user.clean();
						}
						// userManager.emit("saved");
						return {
							data: user,
							requestedAction,
							status: "ok",
						};
					default:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	async saveUserPicture (user) {
		// console.log(user);
		const rd = NousCore.api.createRequest({ item: user.export() });
		const requestedAction = "save-profile-picture";
	
		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			// console.log(data);
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						if (data.items.length > 0) {
							user.import(data.items[0]);
							user.clean();
						}
						// userManager.emit("saved");
						return {
							data: user,
							requestedAction,
							status: "ok"
						};
				}
			}
		});
	}

	async getList () {
		const getListResult = await super.getList();

		const userList = getListResult.data;
		userList.sort((a, b) => {
			if (a.__fullName > b.__fullName) {
				return 1;
			}
			else if (a.__fullName < b.__fullName) {
				return -1;
			}
		});

		Shark.set({
			userList,
		});
		
		return getListResult;
	}

	getListForMyOrganization () {
		var rd = NousCore.api.createRequest();
		const requestedAction = "get-list-for-my-organization";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const userList = Shark.getInstanceList(User, data.items);

						userList.sort((a, b) => {
							if (a.__fullName > b.__fullName) {
								return 1;
							}
							else if (a.__fullName < b.__fullName) {
								return -1;
							}
						});
		
						Shark.set({
							userList,
						});
				
						return {
							data: userList,
							requestedAction,
							status: "ok"
						};
					}
				}
			}
		});
	}

	requestNewPassword (email) {
		var rd = NousCore.api.createRequest({ item: {email}});
		const requestedAction = "request-new-password";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
				
						return {
							data,
							requestedAction,
							status: "ok"
						};
					}
				}
			}
		});
	}

	async uploadProfilePicture (target) {
		return NousCore.api.uploadFiles(target, "user/upload-user-picture", { singleSent: true })
		.then((jsonData) => {
			// console.log({jsonData});
			//NousCore.api.off("singleUploadCompleted", this.uploadManager_singleUploadCompletedHandler);

			// const savedFiles = jsonData.map(item => item.payload.items[0]);
			// console.log({savedFiles});
			const documents = jsonData.payload.items;
	
			// savedFiles.forEach(savedFile => {
			// 	switch (savedFile.rc) {
			// 		case 1: {
			// 			const newDocument = new Document(currDocument);
			// 			// 	{
			// 			// 	fileSize: savedFile.size,
			// 			// 	fileType: savedFile.type,
			// 			// 	fileURL: savedFile.attemptedSavePath,
			// 			// 	name: savedFile.name,
			// 			// 	revision: 0,
			// 			// 	status: 1,
			// 			// 	thumbnailURL: savedFile.thumbnailURL || "",
			// 			// });

			// 			newDocument.set({
			// 				fileURL: savedFile.attemptedSavePath,
			// 				thumbnailURL: savedFile.thumbnailURL || "",
			// 			});
	
			// 			documents.push(newDocument);
			// 			break;
			// 		}
			// 		case 95:
			// 			break;
			// 		default:
			// 			 ("Attezione, si è verificato il seguente errore:\n\n" + savedFile.errors[0].errorDescription);
			// 	}
			// });
	
			return {
				data: documents,
				status: "ok"
			};
		});
	}

	setNewPassword (user) {
		const rd = NousCore.api.createRequest({ item: {otp: Shark.get("tempKey"), ...user.export("logIn")} });
		const requestedAction = "set-new-password";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							requestedAction,
							status: "ok"
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}
}

const userManager = new UserManager();

Shark.registerController(userManager);

export default userManager;